<template>
    <div>
        <b-tabs lazy card>
            <!-- <b-tab title="REQUEST REFUNDS">
                <RefundRequests />
            </b-tab> -->

            <b-tab title="CUSTOMER SERVICE TICKETS">
                <ListCustomerServiceTickets />
            </b-tab>
            <b-tab title="CREATE CUSTOMER SERVICE TICKET">
                <CreateCustomerServiceTickets />
            </b-tab>
             
        </b-tabs>
    </div>
</template>

<script>
    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'

    import ListCustomerServiceTickets from '@/components/CustomerService/ListCustomerServiceTickets'
    import RefundRequests from '@/components/CustomerService/RefundRequests'

    import CreateCustomerServiceTickets from '@/components/CustomerService/CreateCustomerServiceTickets'
    export default {
        name: "CustomerServiceMain",
        components: {
            flatPickr,
            Loading,
            ItemComments,
            ListCustomerServiceTickets,
            RefundRequests,
            CreateCustomerServiceTickets
        },
        data: function(){
            return {}
        },
        methods: {},
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
        }
    }

</script>

<style scoped>
    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomerService/CustomerServiceMain.vue